"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _commonFns = /*#__PURE__*/ _interop_require_wildcard(require("./commonFns"));
const _convertUnits = require("~/helpers/convertUnits");
const _formulaFnHelper = require("~/helpers/formulaFnHelper");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const mysql2 = _extends({}, _commonFns.default, {
    LEN: 'CHAR_LENGTH',
    MIN: 'LEAST',
    MAX: 'GREATEST',
    SEARCH: async (args)=>{
        args.pt.callee.name = 'LOCATE';
        const temp = args.pt.arguments[0];
        args.pt.arguments[0] = args.pt.arguments[1];
        args.pt.arguments[1] = temp;
    },
    INT: async (args)=>{
        return {
            builder: args.knex.raw(`CAST(${(await args.fn(args.pt.arguments[0])).builder} as SIGNED)`)
        };
    },
    LEFT: async (args)=>{
        const source = (await args.fn(args.pt.arguments[0])).builder;
        const needle = (await args.fn(args.pt.arguments[1])).builder;
        return {
            builder: args.knex.raw(`SUBSTR(?,1,?)`, [
                source,
                needle
            ])
        };
    },
    RIGHT: async (args)=>{
        const source = (await args.fn(args.pt.arguments[0])).builder;
        const needle = (await args.fn(args.pt.arguments[1])).builder;
        return {
            builder: args.knex.raw(`SUBSTR(?, -(?))`, [
                source,
                needle
            ])
        };
    },
    MID: 'SUBSTR',
    FLOAT: async (args)=>{
        return {
            builder: args.knex.raw(`CAST(CAST(${(await args.fn(args.pt.arguments[0])).builder} as CHAR) AS DOUBLE)`).wrap('(', ')')
        };
    },
    DATEADD: async ({ fn, knex, pt })=>{
        const date = (await fn(pt.arguments[0])).builder;
        const count = (await fn(pt.arguments[1])).builder;
        if (pt.arguments[2].type === 'Literal') {
            const unit = (0, _commonFns.validateDateAddUnit)(String((await fn(pt.arguments[2])).builder));
            return {
                builder: knex.raw(`CASE
      WHEN ? LIKE '%:%' THEN
        DATE_FORMAT(DATE_ADD(?, INTERVAL ? ${unit}), '%Y-%m-%d %H:%i:%s')
      ELSE
        DATE(DATE_ADD(?, INTERVAL ? ${unit}))
      END`, [
                    date,
                    date,
                    count,
                    date,
                    count
                ])
            };
        }
        // Dynamic unit (field reference) — MySQL requires keyword units,
        // so branch per valid unit to prevent injection.
        // All dynamic values passed via ? bindings, not interpolated.
        const unitExpr = (await fn(pt.arguments[2])).builder;
        const units = [
            ..._commonFns.ALLOWED_DATEADD_UNITS
        ];
        const branches = units.map((u)=>`WHEN LOWER(?) = '${u}' THEN
        CASE WHEN ? LIKE '%:%' THEN
          DATE_FORMAT(DATE_ADD(?, INTERVAL ? ${u.toUpperCase()}), '%Y-%m-%d %H:%i:%s')
        ELSE
          DATE(DATE_ADD(?, INTERVAL ? ${u.toUpperCase()}))
        END`).join('\n');
        return {
            builder: knex.raw(`CASE ${branches} ELSE NULL END`, units.flatMap(()=>[
                    unitExpr,
                    date,
                    date,
                    count,
                    date,
                    count
                ]))
        };
    },
    DATETIME_DIFF: async ({ fn, knex, pt })=>{
        const datetime_expr1 = (await fn(pt.arguments[0])).builder;
        const datetime_expr2 = (await fn(pt.arguments[1])).builder;
        const unit = (0, _convertUnits.convertUnits)(pt.arguments[2] ? (await fn(pt.arguments[2])).builder.bindings[0] : 'seconds', 'mysql');
        if (unit === 'MICROSECOND') {
            // MySQL doesn't support millisecond
            // hence change from MICROSECOND to millisecond manually
            return {
                builder: knex.raw(`TIMESTAMPDIFF(${unit}, ${datetime_expr2}, ${datetime_expr1}) div 1000`)
            };
        }
        return {
            builder: knex.raw(`TIMESTAMPDIFF(${unit}, ${datetime_expr2}, ${datetime_expr1})`)
        };
    },
    WEEKDAY: async ({ fn, knex, pt })=>{
        var _pt_arguments_;
        // WEEKDAY() returns an index from 0 to 6 for Monday to Sunday
        return {
            builder: knex.raw(`(WEEKDAY(${pt.arguments[0].type === 'Literal' ? `'${(0, _dayjs.default)((await fn(pt.arguments[0])).builder).format('YYYY-MM-DD')}'` : (await fn(pt.arguments[0])).builder}) - ${(0, _formulaFnHelper.getWeekdayByText)(pt == null ? void 0 : (_pt_arguments_ = pt.arguments[1]) == null ? void 0 : _pt_arguments_.value)} % 7 + 7) % 7`)
        };
    },
    DAY: async ({ fn, knex, pt })=>{
        return {
            builder: knex.raw(`EXTRACT(DAY FROM ((${(await fn(pt == null ? void 0 : pt.arguments[0])).builder}) + 0))`)
        };
    },
    MONTH: async ({ fn, knex, pt })=>{
        return {
            builder: knex.raw(`EXTRACT(MONTH FROM ((${(await fn(pt == null ? void 0 : pt.arguments[0])).builder}) + 0))`)
        };
    },
    YEAR: async ({ fn, knex, pt })=>{
        return {
            builder: knex.raw(`EXTRACT(YEAR FROM ((${(await fn(pt == null ? void 0 : pt.arguments[0])).builder}) + 0))`)
        };
    },
    HOUR: async ({ fn, knex, pt })=>{
        return {
            builder: knex.raw(`EXTRACT(HOUR FROM ((${(await fn(pt == null ? void 0 : pt.arguments[0])).builder}) + 0))`)
        };
    },
    REGEX_MATCH: async ({ fn, knex, pt })=>{
        const source = (await fn(pt.arguments[0])).builder;
        const pattern = (await fn(pt.arguments[1])).builder;
        return {
            builder: knex.raw(`(? REGEXP ?)`, [
                source,
                pattern
            ])
        };
    },
    REGEX_EXTRACT: async ({ fn, knex, pt })=>{
        const source = (await fn(pt.arguments[0])).builder;
        const pattern = (await fn(pt.arguments[1])).builder;
        return {
            builder: knex.raw(`REGEXP_SUBSTR(?, ?, 1, 1, 'c')`, [
                source,
                pattern
            ])
        };
    },
    REGEX_REPLACE: async ({ fn, knex, pt })=>{
        const source = (await fn(pt.arguments[0])).builder;
        const pattern = (await fn(pt.arguments[1])).builder;
        const replacement = (await fn(pt.arguments[2])).builder;
        return {
            builder: knex.raw(`REGEXP_REPLACE(?, ?, ?, 1, 0, 'c')`, [
                source,
                pattern,
                replacement
            ])
        };
    },
    XOR: async ({ fn, knex, pt })=>{
        const args = await Promise.all(pt.arguments.map(async (arg)=>{
            return {
                builder: (await fn(arg)).builder
            };
        }));
        const predicates = args.map(()=>'?').join(' XOR ');
        return {
            builder: knex.raw(`${predicates}`, args)
        };
    },
    VALUE: async ({ fn, knex, pt })=>{
        const value = (await fn(pt.arguments[0])).builder;
        return {
            builder: knex.raw(`ROUND(CASE
  WHEN :value IS NULL OR REGEXP_REPLACE(:value, '[^0-9.]+', '') IN ('.', '') OR LENGTH(REGEXP_REPLACE(:value, '[^.]+', '')) > 1 THEN NULL
  WHEN LENGTH(REGEXP_REPLACE(:value, '[^%]', '')) > 0 THEN POW(-1, LENGTH(REGEXP_REPLACE(:value, '[^-]',''))) * (REGEXP_REPLACE(:value, '[^0-9.]+', '')) / 100
  ELSE POW(-1, LENGTH(REGEXP_REPLACE(:value, '[^-]', ''))) * (REGEXP_REPLACE(:value, '[^0-9.]+', ''))
END)`, {
                value
            })
        };
    },
    STRING: async (args)=>{
        const source = (await args.fn(args.pt.arguments[0])).builder;
        return {
            builder: args.knex.raw(`CAST(? AS CHAR) `, [
                source
            ])
        };
    },
    JSON_EXTRACT: async ({ fn, knex, pt })=>{
        const source = (await fn(pt.arguments[0])).builder;
        const needle = (await fn(pt.arguments[1])).builder;
        return {
            builder: knex.raw(`CASE WHEN JSON_VALID(:source) = 1 THEN JSON_EXTRACT(:source, CONCAT('$', :needle)) ELSE NULL END`, {
                source,
                needle
            })
        };
    }
});
const _default = mysql2;
